export default {
  init() {
    let firstLoad = true;

    const validDate = function(date) {
      const pattern = /(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19\d\d|20\d\d)/;
      let resultDate = date.replace(pattern,'$3-$2-$1');
      resultDate = isNaN(Date.parse(resultDate)) ? false : resultDate;

      return resultDate;
    }

    const displayDate = function(date) {
      const resultDate = date ? `${date.substring(8,10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`: '';

      return resultDate;
    }

    const setFacetTopLabels = function() {
      // Date Facet Label
      const selected = document.querySelector('.extendedDateFacet .facetwp-radio.checked');
      if (selected) {
        if (selected.dataset.value.includes('range')) {
          // eslint-disable-next-line no-undef
          let selectedValues = FWP.facets.reports_date;

          if(selectedValues.length === 1) {
            selectedValues = selectedValues[0].split(',');
          }
          if(selectedValues.length === 3) {
            document.querySelector('.extendedDateFacet .fs-label').innerHTML = `${displayDate(selectedValues[1])} - ${displayDate(selectedValues[2])}`;
          } else {
            document.querySelector('.extendedDateFacet .fs-label').innerHTML = 'Range';
          }
        } else {
          document.querySelector('.extendedDateFacet .fs-label').innerHTML = selected.innerHTML;
        }
      }
      if (document.querySelector('.extendedDateFacet .fs-label') && document.querySelector('.extendedDateFacet .fs-label').innerHTML === 'All') {
        document.querySelector('.extendedDateFacet .fs-label').innerHTML = 'Filter by date';
      }

      // Topics Label
      if (document.querySelector('.facetwp-facet-reports_topics .fs-label') && document.querySelector('.facetwp-facet-reports_topics .fs-label').innerHTML === 'All') {
        document.querySelector('.facetwp-facet-reports_topics .fs-label').innerHTML = 'Filter by topic';
      }
    }

    const setTouchDeviceDatePlaceholder = function () {
      const date = $('.facetwp-date');

      date.each(function() {
        const dateVal = $(this).val();

        if (dateVal) {
          $(this).removeClass('facetwp-date--placeholder');
        } else {
          $(this).addClass('facetwp-date--placeholder');
        }
      });
    }

    const performDateRangeFilter = function (elem) {
      const $facet = $(elem).closest('.facetwp-facet');
      const facet_name = $facet.attr('data-name');
      if ( elem.dataset.value.includes('range') ) {
        const startDate = $(elem).find('.facetwp-date-min').val();
        const endDate = $(elem).find('.facetwp-date-max').val();
        const startDateValid = startDate ? validDate(startDate) : '0000-01-01';
        const endDateValid = endDate ? validDate(endDate) : '9999-12-31';
        if (startDateValid && endDateValid) {
          elem.dataset.value = ['range', startDateValid, endDateValid];
          $(elem).trigger( 'click' );
          // eslint-disable-next-line no-undef
          FWP.frozen_facets[facet_name] = 'soft';
          // eslint-disable-next-line no-undef
          FWP.autoload();
          $facet.find('.ed-date-range__error').text('');
          $(elem).closest('.fs-dropdown').addClass('fs-hidden');
          $(elem).closest('.extendedDateFacet').addClass('is-loading');
        } else {
          $(elem).closest('.extendedDateFacet').removeClass('is-loading');
          $facet.find('.ed-date-range__error').text('Please enter a date in the format dd/mm/yyyy');
        }
      }
    }

    const initDateFacet = function() {
      const wraps = document.querySelectorAll('.extendedDateFacet');

      // Handle dropdown
      wraps.forEach(wrap => {
        const labelWrap = wrap.querySelector('.fs-label-wrap');

        labelWrap.addEventListener('click', () => {
          labelWrap.classList.toggle('fs-open');
          wrap.querySelector('.fs-dropdown').classList.toggle('fs-hidden');
        });

        document.addEventListener('click', event => {
          if (!wrap.contains(event.target)) {
            document.querySelectorAll('.extendedDateFacet .fs-dropdown').forEach(dropdown => {
              if (!dropdown.classList.contains('fs-hidden')) {
                dropdown.classList.add('fs-hidden');
              }
            });

            document.querySelectorAll('.extendedDateFacet .fs-label-wrap').forEach(wrap => {
              if (wrap.classList.contains('fs-open')) {
                wrap.classList.remove('fs-open');
              }
            });
          }
        });
      });

      // Disable default response to click on date range input fields (to prevent selecting this option before the dates are entered).
      $(document).on('click', '.ed-date-range__date input', function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.showPicker();
      });

      // Perform date filter when calendar changes
      if(window.matchMedia('(pointer: coarse)').matches) {
        $(document).on('focusout', '.ed-date-range__date', function(event) {
          performDateRangeFilter(event.target.closest('.facetwp-radio'));
        });
      } else {
        $(document).on('change', '.ed-date-range__date', function(event) {
          performDateRangeFilter(event.target.closest('.facetwp-radio'));
        });
      }

      document.addEventListener('facetwp-loaded', function() {
        setFacetTopLabels();
        setTouchDeviceDatePlaceholder();
        $('.extendedDateFacet').removeClass('is-loading');

        if (firstLoad) {
          $(document).on('click', '.fs-option, .facetwp-radio', function() {
            $('.extendedDateFacet').addClass('is-loading');
          });

          //Handle dates on date range input fields
          $(document).on('keypress', '.extendedDateFacet .facetwp-radio', function(event) {
            if ('Enter' === event.key) {
              performDateRangeFilter(this);
            }
          });
          firstLoad = false;
        }
      });

      setFacetTopLabels();
    }
    initDateFacet();
  },
};



// WEBPACK FOOTER //
// ./scripts/components/extended-date-facet.js